

export const LOG_SUC_200="LOG-SUC-200"
export const LOG_SUC_201="LOG-SUC-201"
export const LOG_SUC_202="LOG-SUC-202"
export const LOG_SUC_203="LOG-SUC-203"
export const LOG_ERR_101="LOG-ERR-101"
export const LOG_ERR_102="LOG-ERR-102"
export const LOG_ERR_103="LOG-ERR-103"
export const LOG_ERR_104="LOG-ERR-104"
export const LOG_ERR_105="LOG-ERR-105"
export const LOG_ERR_106="LOG-ERR-106"
export const LOG_ERR_107="LOG-ERR-107"

export const UNK_ERR_102 = "UNK-ERR-102"

export const FIRST_TIME_CHANGE_PASSWORD_200="FT-CHG-PWD-SUC-200"
export const FIRST_TIME_CHANGE_PASSWORD_201="FT-CHG-PWD-SUC-201"
export const FIRST_TIME_CHANGE_PASSWORD_101="FT-CHG-PWD-ERR-101"
export const FIRST_TIME_CHANGE_PASSWORD_102="FT-CHG-PWD-ERR-102"
export const FIRST_TIME_CHANGE_PASSWORD_103="FT-CHG-PWD-ERR-103"
export const FIRST_TIME_CHANGE_PASSWORD_104="FT-CHG-PWD-ERR-104"
export const FIRST_TIME_CHANGE_PASSWORD_105="FT-CHG-PWD-ERR-105"
export const FIRST_TIME_CHANGE_PASSWORD_106 ="FT-CHG-PWD-ERR-106"
export const FIRST_TIME_CHANGE_PASSWORD_107="FT-CHG-PWD-ERR-107"

export const CHANGE_PASSWORD_200="CHG-PWD-SUC-200"
export const CHANGE_PASSWORD_201="CHG-PWD-SUC-201"
export const CHANGE_PASSWORD_101="CHG-PWD-ERR-101"
export const CHANGE_PASSWORD_102="CHG-PWD-ERR-102"
export const CHANGE_PASSWORD_103="CHG-PWD-ERR-103"
export const CHANGE_PASSWORD_104="CHG-PWD-ERR-104"
export const CHANGE_PASSWORD_105="CHG-PWD-ERR-105"
export const CHANGE_PASSWORD_106 ="CHG-PWD-ERR-106"
export const CHANGE_PASSWORD_107 ="CHG-PWD-ERR-107"

export const RESET_PASSWORD_200="RST-PWD-SUC-200"
export const RESET_PASSWORD_201="RST-PWD-SUC-201"
export const RESET_PASSWORD_101="RST-PWD-ERR-101"
export const RESET_PASSWORD_102="RST-PWD-ERR-102"
export const RESET_PASSWORD_103="RST-PWD-ERR-103"
export const RESET_PASSWORD_104="RST-PWD-ERR-104"
export const RESET_PASSWORD_105="RST-PWD-ERR-105"
export const RESET_PASSWORD_106 ="RST-PWD-ERR-106"

export const CFM_RST_PASSWD_SUC_200="CFM-RST-PWD-SUC-200"
export const  CFM_RST_PASSWD_SUC_201="CFM-RST-PWD-SUC-201"
export const  CFM_RST_PASSWD_ERR_101="CFM-RST-PWD-ERR-101"
export const CFM_RST_PASSWD_ERR_102="CFM-RST-PWD-ERR-102"
export const  CFM_RST_PASSWD_ERR_103="CFM-RST-PWD-ERR-103"
export const  CFM_RST_PASSWD_ERR_104="CFM-RST-PWD-ERR-104"
export const  CFM_RST_PASSWD_ERR_105="CFM-RST-PWD-ERR-105"
export const  CFM_RST_PASSWD_ERR_106="CFM-RST-PWD-ERR-106"


export const FETCH_MFA_SCAN_BAR_ERR_100="MFA-SETUP-ERR-100"
export const FETCH_MFA_SCAN_BAR_ERR_101="MFA-SETUP-ERR-101"
export const FETCH_MFA_SCAN_BAR_SUC_200="MFA-SETUP-SUC-100"

export const MFA_CFM_ERR_100 = "MFA-CFM-ERR-100"
export const MFA_CFM_ERR_103= "MFA-CFM-ERR-103"
export const MFA_CFM_ERR_101="MFA-CFM-ERR-101"
export const MFA_CFM_SUC_200 = "MFA-CFM-SUC-200"

export const MFA_VER_SUC_200 = "MFA-VER-SUC-200"
export const MFA_VER_SUC_201 = "MFA-VER-SUC-201"
export const MFA_VER_ERR_100 = "MFA-VER-ERR-100"
export const MFA_VER_ERR_101 = "MFA-VER-ERR-101"
export const MFA_VER_ERR_102 ="MFA-VER-ERR-102"
export const MFA_VER_ERR_103 ="MFA-VER-ERR-103"
export const MFA_VER_ERR_104 ="MFA-VER-ERR-104"
export const MFA_VER_ERR_105 ="MFA-VER-ERR-105"
export const MFA_VER_ERR_106="MFA-VER-ERR-106"
export const MFA_VER_ERR_107="MFA-VER-ERR-107"

export const VAL_TOK_SUC_200 = "VAL-TOK-SUC-200"
export const VAL_TOK_ERR_100 = "VAL-TOK-ERR-100"
export const VAL_TOK_ERR_101 = "VAL-TOK-ERR-101"
export const VAL_TOK_ERR_102 = "VAL-TOK-ERR-102"
export const VAL_TOK_ERR_103 = "VAL-TOK-ERR-103"
export const VAL_TOK_ERR_104 = "VAL-TOK-ERR-104"
export const VAL_TOK_ERR_105 = "VAL-TOK-ERR-105"

export const UNAUTH_STAT_CODE='UNAUTHORIZED-ERR'
export const UNAUTH_STAT_CODE_101='UNAUTHORIZED-ERR-101'

export const REF_TOK_SUC_200="REF-TOK-SUC-200"
export const SUCCESS_CODES = {
    LOGIN:[LOG_SUC_200,LOG_SUC_201,LOG_SUC_202,LOG_SUC_203],
    FIRST_TIME_CHANGE_PASSWORD:[FIRST_TIME_CHANGE_PASSWORD_200,FIRST_TIME_CHANGE_PASSWORD_201],
    CHANGE_PASSWORD:[CHANGE_PASSWORD_200],
    FETCH_MFA_SCAN_BAR:[FETCH_MFA_SCAN_BAR_SUC_200],
    MFA_SETUP_CODE_VERIFY:[MFA_CFM_SUC_200],
    MFA_VERIFY_TOKEN:[MFA_VER_SUC_200,MFA_VER_SUC_201],
    RESET_PASSWORD:[RESET_PASSWORD_200],
    CFM_RESET_PASSWORD:[CFM_RST_PASSWD_SUC_200],
    VAL_SESS_TOKEN:[VAL_TOK_SUC_200]

}
export const ERR_MSG= "Unknown error occurred. Please contact dso_class_license@lta.gov.sg for assistance."
export const SESS_EXPIRED_TITLE="Session Expired"
export const SESS_EXPIRED_TEXT= "Session has expired.Please re-login."
export const CHG_PWD_SUC="Your password has been changed.Please re-login."
export const CHG_PWD_SUC_TITLE="Password Changed"
export const TEMP_PASS_EXPIRED="Temporary password has expired. Please contact dso_class_license@lta.gov.sg for assistance."
export const LOGIN_CRED_ERR="The username or password is incorrect."
export const CURR_PASS_ERR="The current password is incorrect."
export const LOGIN_ATTEMPT_ERR="Maximum number of attempts exceeded. Please try again later."
export const CHG_PWD_POLICY_ERR= "Password does not confirm the policy."

export const MFA_OTP_WRONG_ERR="Invalid OTP code entered. Please try again."
export const MFA_OTP_TRY_AGAIN_ERR= "OTP code has expired. Please try again with next generated OTP."
export const RESET_PASS_USERNAME_ERR= "The given username is incorrect."

